import React from "react";
import { Link } from "react-router-dom";
import { BedDouble, Bath, Maximize, MapPin, Tag } from "lucide-react";
import StatusBadge from "./StatusBadge";
import { formatPrice, formatBath } from "../mock/mock";
import { mediaUrl, thumbUrl } from "../lib/api";

export default function PropertyCard({ property }) {
  const tags = property.tags || [];
  const bath = formatBath(property.bathrooms);
  const hasBeds = property.bedrooms !== null && property.bedrooms !== undefined && property.bedrooms !== 0;
  const bedsText = hasBeds ? property.bedrooms : property.bedrooms_label;
  const hasArea = property.area !== null && property.area !== undefined && property.area !== 0;
  const areaText = hasArea ? `${property.area} m²` : property.area_label;
  const loc = property.address || [property.sub_location, property.location].filter(Boolean).join(", ") || property.location;
  return (
    <Link
      to={`/proprietes/${property.id}`}
      className="prop-card group block bg-white rounded-lg overflow-hidden border border-slate-100 shadow-sm"
    >
      <div className="relative h-60 overflow-hidden">
        <img
          src={thumbUrl(property.image, 640)}
          alt={property.title}
          loading="lazy"
          decoding="async"
          className="prop-img w-full h-full object-cover bg-slate-100"
        />
        <div className="absolute top-4 left-4 flex flex-col gap-2 items-start">
          <StatusBadge status={property.status} />
          {tags.map((t) => (
            <span key={t} className="inline-flex items-center gap-1 bg-[#1156a7] text-white text-[11px] font-600 px-2.5 py-1 rounded-full shadow">
              <Tag size={11} /> {t}
            </span>
          ))}
        </div>
        {property.listing_type === "location" && (
          <span className="absolute top-4 right-4 bg-white/90 text-[#1156a7] text-[11px] font-700 px-2.5 py-1 rounded-full">À louer</span>
        )}
      </div>
      <div className="p-6">
        {/* Price first, larger */}
        <p className="font-serif-display text-3xl text-[#0b1f33] leading-none">
          {formatPrice(property.price, property.currency, property.price_from)}
          {property.listing_type === "location" && property.price != null && <span className="text-sm text-slate-400 font-sans"> /mois</span>}
        </p>
        {/* Title */}
        <h3 className="text-lg font-600 text-[#0b1f33] mt-3 group-hover:text-[#1156a7] transition-colors">
          {property.title}
        </h3>
        {/* Address */}
        {loc && (
          <p className="flex items-center gap-1.5 text-sm text-slate-500 mt-1">
            <MapPin size={14} className="text-[#1156a7]" /> {loc}
          </p>
        )}
        {/* Icons — hide items with no value, never show 0 */}
        {(bedsText || bath || areaText) && (
          <div className="flex items-center gap-5 mt-4 pt-4 border-t border-slate-100 text-sm text-slate-600">
            {bedsText && <span className="flex items-center gap-1.5"><BedDouble size={16} className="text-[#1156a7]" /> {bedsText}</span>}
            {bath && <span className="flex items-center gap-1.5"><Bath size={16} className="text-[#1156a7]" /> {bath}</span>}
            {areaText && <span className="flex items-center gap-1.5"><Maximize size={16} className="text-[#1156a7]" /> {areaText}</span>}
          </div>
        )}
      </div>
    </Link>
  );
}
